<template>
  <v-app :class="{ 'open-sidebar' : primaryDrawer }" v-resize="onResize">
    <template v-if="!$route.meta.public && token && !config.DEV_MODULE">
      <i4proSidebar v-if="(configLayout.sidebar && !handleSidebarSearch) || innerWidth <= 200" :model="primaryDrawer" @setFooterMargin="footerMargin = $event" @setPrimaryDrawer="setPrimaryDrawer($event)" />
      <i4proSidebarSearch v-if="(configLayout.sidebar && !!handleSidebarSearch) || innerWidth <= 200" :model="primaryDrawer" />

      <i4proHeader :innerWidth="innerWidth">
        <template v-if="(configLayout.sidebar || innerWidth <= 200) && !permanentSidebar" v-slot:sidebar>
          <v-icon id="menu-icon" i4pro-id="header-menu-icon" dark @click.stop="primaryDrawer = !primaryDrawer" class="mr-2">menu</v-icon>
        </template>
      </i4proHeader>

      <v-main id="mainContent" :style="background">
        <div>
          <v-overlay v-if="dinamicDrawer" :value="dinamicDrawer" z-index="4" />
          <i4proSidebarDinamic @dinamicDrawer="updateDinamicDrawer" />

          <transition name="page">
            <router-view></router-view>
          </transition>
        </div>
      </v-main>

      <v-footer app v-if="configFooter.visible" v-bind="configFooter.atributes" :style="[backgroundFooter, marginLeftFooter]">
        <i4pro-form class="content" v-if="showForm && configFooter.showPage" :page="configFooter.page" :context="configFooter.mode" />

        <span v-if="!configFooter.showPage" class="px-3">&copy; {{ new Date().getFullYear() }}</span>
        <v-spacer/>
        <span v-if="configFooter.logo">
          <span v-if="configFooter.logo.url">
          <a :href="configFooter.logo.url" target="_blank">
          <img
            :src="configFooter.logo.src"
            :alt="configFooter.logo.alt"
            :width="configFooter.logo.width"
            :height="configFooter.logo.height"
          />
          </a>
          </span>
          <span v-if="!configFooter.logo.url">
            <img
            :src="configFooter.logo.src"
            :alt="configFooter.logo.alt"
            :width="configFooter.logo.width"
            :height="configFooter.logo.height"
          />
          </span>
        </span>
      </v-footer>

      <i4proBackToTop v-if="configLayout.hideButtonToTop != true" />
      <i4proDialogAcceptTerms :dialog="acceptTerm.isAcceptTerms" :acceptTerm="acceptTerm" />
    </template>

    <template v-else-if="!$route.meta.public && token && config.DEV_MODULE">
      <router-view :key="$route.fullpath"></router-view>
    </template>

    <template v-else>
      <v-main id="mainContent" class="reset-content">
        <transition name="page">
          <keep-alive>
            <router-view :key="$route.fullpath"></router-view>
          </keep-alive>
        </transition>
      </v-main>
    </template>

    <i4proSnackBar />
    <i4proDialogError500 v-bind="getError500" />
    <i4proLoader />
    <i4proPrivacy />
  </v-app>
</template>

<script>
import store from '@/store';
import * as HANDLERS from '@/helpers/types/handlers';
import { getGoogleApiKey } from '@/services/maps';

export default {
  name: 'App',
  
  components: {
    i4proBackToTop: () => import('@/components/buttons/i4pro-back-to-top'),
    i4proHeader: () => import('@/components/headers/i4pro-header'),
    i4proSidebar: () => import('@/components/sidebar/i4pro-sidebar'),
    i4proSidebarSearch: () => import('@/components/sidebar/i4pro-sidebar-search'),
    i4proSnackBar: () => import('@/components/snackbars/i4pro-snackbar'),
    i4proDialogError500: () => import('@/components/errors/i4pro-dialog-error-500'),
    i4proSidebarDinamic: () => import('@/components/sidebar/i4pro-sidebar-dinamic'),
    i4proForm: () => import('@/components/layouts/i4pro-form'),
    i4proLoader: () => import('@/components/loader/i4pro-loader'),
    i4proPrivacy: () => import('@/components/privacy/i4pro-privacy'),
    i4proDialogAcceptTerms: () => import('@/components/dialogs/i4pro-dialog-accept-terms')
  },

  data: () => ({
    primaryDrawer: false,
    dinamicDrawer: false,
    innerWidth: 0,
    background: '',
    showForm: false,
    backgroundFooter: '',
    footerMargin: 0,
  }),

  mounted() {
    store.dispatch('loading/finishLoading');
    this.onResize();
  },

  events: {
    [HANDLERS.SHOW_BACKGROUND]: 'changeBackground',
    [HANDLERS.ENABLE_FOOTER]: 'loaddingFooter'
  },

  async beforeCreate() {
    await store.dispatch('authentication/getConfig');

    const layout = store.getters['layout/getConfigLayout'];
    this.$vuetify.theme.dark = layout.dark;

    const theme = store.getters['layout/getConfigTheme'];

    for (let [key, value] of Object.entries(theme)) {
      if (value) {
        this.$vuetify.theme.themes.light[key] = value;
        this.$vuetify.theme.themes.dark[key] = value;
      }
    }
    await this.setGoogleMapsKey();
    this.getClientIdByURL();

    const configLogin = store.getters['layout/getConfigLogin'];

    if ('bypass' in configLogin && configLogin.bypass === true && this.$route.name === "Login") {
      await store.dispatch('authentication/login');
    }
  },

  created() {
    store.dispatch('loading/startLoading');

    window.addEventListener('beforeunload', function (e) {
      this.logoff;
    });

    window.addEventListener('unload', function (e) {
      this.logoff;
    });
  },

  computed: {
    token: () => store.getters['authentication/getToken'],

    configLayout() {
      const layout = store.getters['layout/getConfigLayout'];

      this.$vuetify.theme.dark = layout.dark;

      return layout;
    },

    handleSidebarSearch: () =>  store.getters['layout/getConfigSidebar'].search || false,

    configFooter: () => store.getters['layout/getConfigFooter'],

    configSidebar: () => store.getters['layout/getConfigSidebar'],

    getError500: () => store.getters['errors/getError500'].options,

    config: () => store.getters['authentication/getConfig'],

    acceptTerm: () => store.getters['authentication/getAcceptTerms'],

    marginLeftFooter() {
      if (!this.permanentSidebar) {
        return ''
      }

      return {
        marginLeft: `${this.footerMargin}px`
      }
    },

    permanentSidebar() {
      return !!this.configSidebar.permanent && !this.$vuetify.breakpoint.smAndDown
    },
  },

  methods: {
    getClientIdByURL() {
      const urlKeyToClientID = window.location.origin + window.location.pathname;

      if (urlKeyToClientID) {
        store.dispatch('authentication/changeClientId', urlKeyToClientID );
      }
    },

    async setGoogleMapsKey() {
      const { status, data } = await getGoogleApiKey();

      if (status === 200) {
        let script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${data}&libraries=drawing,places`;
        document.head.appendChild(script);
      }
    },
    logoff() {
      store.dispatch('authentication/logoff');
    },
    onResize() {
      this.innerWidth = window.innerWidth;
    },

    changeBackground(item) {
      this.background = '';
      let mainBackground = this.configLayout.backgroundColor;
      let widthPage = window.innerWidth;
      let style = 'background-size: cover; background-position: center center; background-attachment: fixed;';

      if (!item) return;

      let isBg = false;
      Object.values(item).forEach(item => {
        if (item) isBg = true;
      });

      if (!isBg) return;

      if (widthPage > 768) {
        if (item.desktopImage) this.background = `background-image: url(' ${item.desktopImage} '); ${style}`;

        else if (item.desktopColor) this.background = `background-color: ${item.desktopColor}`;

        else if(mainBackground) this.background = `background-color: ${mainBackground}`;
      } 
      else {
        if (item.mobileImage) this.background = `background-image: url(' ${item.mobileImage} '); ${style}`;

        else if (item.mobileColor) this.background = `background-color: ${item.mobileColor}`;

        else if(mainBackground) this.background = `background-color: ${mainBackground}`;
      }

      if (this.configFooter.spacingBetweenContent) {
        this.background = `${this.background}; padding-bottom: ${this.configFooter.spacingBetweenContent}`;
      }
    },

    changeBackgroundFooter() {
      this.backgroundFooter = '';
      let style = 'background-size: cover; background-position: center center; background-attachment: fixed;';

      if (this.configFooter.background.image) {
        this.backgroundFooter = `background-image: url(' ${this.configFooter.background.image} '); ${style}`;
      }

      if (this.configFooter.background.color) {
        this.backgroundFooter = `background-color: ${this.configFooter.background.color} ;`;
      }
    },

    async loaddingFooter() {
      if (this.configFooter.visible && this.configFooter.page && this.configFooter.mode) {
        await store.dispatch('page/load', { page: this.configFooter.page, mode: this.configFooter.mode });
        this.showForm = true;

        this.changeBackgroundFooter();
      }
    },

    updateDinamicDrawer(state) {
      this.dinamicDrawer = state;
    },

    setPrimaryDrawer(event) {
      this.primaryDrawer = !event

      this.$nextTick(() => {
        this.primaryDrawer = event
      })
    },
  }
};
</script>
